import {CREATE_BANNER_START} from "../../types";

export const create_banner = (payload) => ({
  type: CREATE_BANNER_START,
  payload,
});
